import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Box,
} from '@mui/material';
import { Warning as WarningIcon } from '@mui/icons-material';
import ModernButton from '../common/ModernButton';

const ConfirmDialog = ({
  open,
  onClose,
  onConfirm,
  title = 'Confirm Action',
  message = 'Are you sure you want to proceed?',
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  confirmColor = 'error',
  icon = <WarningIcon />,
  loading = false,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: { borderRadius: 3 }
      }}
    >
      <DialogTitle sx={{ pb: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Box sx={{
            color: confirmColor === 'error' ? 'error.main' : 'warning.main',
            display: 'flex'
          }}>
            {icon}
          </Box>
          {title}
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography color="text.secondary">
          {message}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <ModernButton
          variant="outlined"
          onClick={onClose}
          disabled={loading}
        >
          {cancelText}
        </ModernButton>
        <ModernButton
          variant="contained"
          color={confirmColor}
          onClick={onConfirm}
          loading={loading}
        >
          {confirmText}
        </ModernButton>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
